import React from "react";
import { Hamburger } from "./HamburgerStyles";
const NavHamburger = ({ open, toggle }) => {
    const mobileNavClass = open ? "mobile-nav-open" : "mobile-nav-closed";
    return (React.createElement(Hamburger, { className: `navbar-toggler navbar-toggler-right custom-toggler pull-left mx-2 ${mobileNavClass}`, onClick: () => toggle(!open) },
        React.createElement("span", { className: "icon-bar top-bar" }),
        React.createElement("span", { className: "icon-bar middle-bar" }),
        React.createElement("span", { className: "icon-bar bottom-bar" }),
        React.createElement("span", { className: "sr-only" }, "Toggle navigation")));
};
export default NavHamburger;
//# sourceMappingURL=NavHamburger.js.map